import React from "react";
import { useTranslation } from "react-i18next";
import {
  useCreateStrategicAxis,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { StrategicAxis, strategicAxis } from "@planzone/dto";
import { Form } from "./form";
import { Props } from "./types";
import styles from "./styles.scss";

function StrategicAxisCreation({ cancel }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { isRequestPending, createStrategicAxis } = useCreateStrategicAxis();
  const [formData, setFormData] = React.useState<StrategicAxis>(strategicAxis);

  return (
    <Modal header={t("strategicAxesPage.creation.title")} close={cancel}>
      <form
        className={styles.strategicAxisCreation}
        onSubmit={(e) => {
          e.preventDefault();

          !isRequestPending &&
            createStrategicAxis({ planzone, strategicAxis: formData });
        }}
      >
        <div className={styles.form}>
          <Form formData={formData} edit={setFormData} />
        </div>
        <div className={styles.footer}>
          <Button type="cancel" press={cancel}>
            {t("strategicAxesPage.creation.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
          >
            {t("strategicAxesPage.creation.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { StrategicAxisCreation };
